/**
 * Contiene el código original previo al refactor
 */

import { setVisitTag } from "./functions/setVisitTag";

//window.location.search.indexOf("walmericTest") != -1
window.waitBysideToLoadSecure = true;


if (flagOnlyOne != true) {
  var flagOnlyOne = true;
  var waitBysideToLoad = setInterval(function () {
    //save phones
    var avoidRingPoolDefault = document.createElement("div");
    avoidRingPoolDefault.innerHTML =
      '<div class="customDSABigTextPhone drp-phone wal-drp-phone html-drp-phone" style="display:none"></div>';
    var bodyEnd = document.getElementsByTagName("body")[0];
    if (bodyEnd) {
      bodyEnd.appendChild(avoidRingPoolDefault);
    }

    //end save phone

    //check parent href html-drp-phone
    // var htmlPhonesWithoutMainClass =
    //   document.getElementsByClassName("html-drp-phone");
    // for (var i = 0, len = htmlPhonesWithoutMainClass.length; i < len; i++) {
    //   var elementoWithoutMainClass = htmlPhonesWithoutMainClass[i];
    //   if (
    //     typeof elementoWithoutMainClass.parentElement.href != "undefined" &&
    //     elementoWithoutMainClass.parentElement.href.indexOf("tel:") > -1 &&
    //     elementoWithoutMainClass.parentElement.className.indexOf(
    //       "wal-drp-phone"
    //     ) == -1
    //   ) {
    //     elementoWithoutMainClass.parentElement.className += " wal-drp-phone";
    //   }
    // }
    // end check parent href html-drp-phone

    clearInterval(waitBysideToLoad);
    waitBysideToLoadSecure = false;

    if (
      typeof window.DFI_client == "undefined" &&
      window.location.search.indexOf("walmericTest") > -2
    ) {
      if (typeof window.DFI_client != "object") {
        window.DFI_client = {};
      }

      //DFI_client.defaultPhone ="210206442";
      DFI_client.defaultPhone = "800181461";
      DFI_client.defaultPhoneUnavailable = "800181459";

      setVisitTag();

      DFI_client.buildMaskString = function (string, mask) {
        mask =
          mask ||
          "##########################################################################################################";
        var formatedString = "",
          lastPosition = 0,
          pattern = mask.split(" ");
        for (var index in pattern)
          (formatedString +=
            string.substr(lastPosition, pattern[index].length) + " "),
            (lastPosition += pattern[index].length);
        return (formatedString = formatedString.replace(/\s+$/gi, ""));
      };

      DFI_client.checkDevice = () => {
        var check = false;
        (function (a) {
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
              a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4)
            )
          )
            check = "mobile";
        })(navigator.userAgent || navigator.vendor || window.opera);
        if (window.matchMedia("(orientation: portrait)").matches) {
          if (screen.width > 767) {
            check = "desktop";
          }
        }
        if (window.matchMedia("(orientation: landscape)").matches) {
          if (screen.height > 767) {
            check = "desktop";
          }
        }
        return check;
      };
      window.DFI_client.ringpoolclasses = function (
        phoneNumber1,
        phoneNumber2
      ) {
        const elements = document.querySelectorAll("a[href^='tel:']");

        elements.forEach((element) => {
          const href = element.getAttribute("href");
          const innerHTML = element.innerHTML;

          if (
            href.includes(phoneNumber1) &&
            !element.classList.contains("wal-drp-phone")
          ) {
            element.classList.add("wal-drp-phone");
          }

          if (
            innerHTML.includes(phoneNumber2) &&
            !element.classList.contains("html.drp-phone")
          ) {
            element.classList.add("html.drp-phone");
          }
        });
      };

      window.DFI_client.ringpoolclasses = function (
        phoneNumber1,
        phoneNumber2
      ) {
        const elements = document.querySelectorAll("a[href^='tel:']");

        elements.forEach((element) => {
          const href = element.getAttribute("href");
          const innerHTML = element.innerHTML;

          if (
            href.includes(phoneNumber1) &&
            !element.classList.contains("wal-drp-phone")
          ) {
            element.classList.add("wal-drp-phone");
          }

          if (
            innerHTML.includes(phoneNumber2) &&
            !element.classList.contains("html.drp-phone")
          ) {
            element.classList.add("html.drp-phone");
          }
        });
      };

      var htmlPhones = document.getElementsByClassName("html-drp-phone");
      for (var i = 0, len = htmlPhones.length; i < len; i++) {
        var elemento = htmlPhones[i];
        elemento.innerHTML = DFI_client.buildMaskString(
          DFI_client.defaultPhoneUnavailable,
          "### ### ###"
        );
        elemento.href = "tel:" + DFI_client.defaultPhoneUnavailable;
      }

      DFI_client.ringpoolclasses("800607706", "800 607 706");
      //Name space functions
      DFI_client.getUrlVar = function (variable, url) {
        var href = url || window.location.search;
        var i, pair;
        var query = href.split("?")[1];
        var vars = query ? query.split("&") : [];

        for (i = 0; i < vars.length; i++) {
          pair = vars[i].split("=");

          if (pair[0] == variable && pair[1] !== "") return pair[1];
        }

        return "";
      };

      DFI_client.getCookie = function (name) {
        let match = document.cookie.match(new RegExp(name + "=([^;]+)"));
        if (match) return match[1];
      };

      DFI_client.setCookie = function (name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      };

      /*Funcion que elimina el wal-drp-phone causado por la funcion ringpoolclasses , usar si lo que queremos es un numero fijo */
      const existRingpool = setInterval(() => {
        const device = DFI_client.checkDevice();
        if (device == "mobile") {
          const targetRinpoolMobile = document.querySelector(
            ".wm_ringpoolmobile-text"
          );
          if (
            typeof targetRinpoolMobile != "undefined" &&
            targetRinpoolMobile != null
          ) {
            clearInterval(existRingpool);
            targetRinpoolMobile.href = "tel:800606060";
            targetRinpoolMobile.classList.remove("wal-drp-phone");
          }
        } else {
          const targetRingpoolDevice =
            document.querySelector(".wm_ringpool-text");
          if (
            typeof targetRingpoolDevice != "undefined" &&
            targetRingpoolDevice != null
          ) {
            clearInterval(existRingpool);
            targetRingpoolDevice.href = "tel:800606060";
            targetRingpoolDevice.classList.remove("wal-drp-phone");
          }
        }
      }, 500);

      // DFI_client.getMinutes = function (minutosLlamar) {
      //   // Obtener la hora actual
      //   var ahora = new Date();

      //   // Obtener los minutos de la hora actual
      //   var minutosActuales = ahora.getHours() * 60 + ahora.getMinutes();

      //   // Obtener los minutos de la hora específica
      //   var minutosEspecificos = minutosLlamar;

      //   if (minutosEspecificos >= 0 && minutosEspecificos <= 60) {
      //     var diferenciaMinutos = minutosEspecificos;
      //     return diferenciaMinutos;
      //   } else {
      //     // Calcular la diferencia de minutos
      //     var diferenciaMinutos = minutosEspecificos - minutosActuales;

      //     // Manejar casos en los que la hora específica ya ha pasado
      //     if (diferenciaMinutos < 0) {
      //       diferenciaMinutos += 24 * 60; // Sumar 24 horas en minutos
      //     }
      //     return diferenciaMinutos;
      //   }
      // };

      DFI_client.openPopPupMobile = (elementoDom, modal_opened, clase) => {
        const elementoDomMobile = elementoDom;
        if (elementoDomMobile && modal_opened) {
          modal_opened.forEach((elem) => {
            elem.classList.toggle(clase);
          });
        }
      };

      //End Name space functions
      if (
        window.location.href.includes("/l/oferta/plano-protocolo/SECURITAS") ||
        window.location.href.includes("/l/oferta/plano-protocolo/BCP")
      )
        waitBysideToLoadSecure = true;
      if (
        (typeof bysideWebcare_set_calltracker_number === "function" &&
          waitBysideToLoadSecure) ||
        waitBysideToLoadSecure
      ) {
        var bw_uuid = bysideWebcare_get_visitor_UUID();
        DFI_client.dataLayer = {};
        DFI_client.dataLayer["byside"] = encodeURIComponent(bw_uuid);
        DFI_client.dataLayer["bysideId"] = encodeURIComponent(bw_uuid);
        DFI_client.dataLayer["url_sinparametros"] = encodeURI(
          window.location.origin
        );
        DFI_client.dataLayer["url_completa"] = encodeURI(window.location.href);
        DFI_client.dataLayer["url_source"] = encodeURI(window.location.href);

        // etiquetas GA
        DFI_client.dataLayer["userAgent"] = encodeURI(
          window.navigator.userAgent
        );
        DFI_client.dataLayer["clientId"] = DFI_client.getCookie("_ga");

        DFI_client.dataLayer["device_type"] = DFI_client.checkDevice();

        // etiqueta visita 5
        DFI_client.dataLayer["url_source_sin_parametros"] =
          location.href.split("?")[0];
      }

      window.idTagDelio =
        "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a93e99c8370bea01bdf71d694d56ec4d64bba05f118f7c84996a57b4073cfbe20c2aed7106a030ac8be06095492c118b06096cc690787ae062cbde744f7ac2f4b256247fe228851963a09ff2bbc9a5a2b";
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://t.womtp.com/slider/c/delio-lm/dfi/init.js";
      var head = document.getElementsByTagName("head")[0];
      script.classList.add("optanon-category-C0001");
      head.appendChild(script);

      var wmTelInit = "";
      var wmTelLast = "1";

      // const addHorario = setInterval(() => {
      //   const wm_dsa = document.querySelector("#dsa-newId");
      //   const wm_values = document.querySelector("#wm_shedule-values");
      //   let minutes = document.getElementsByName("minutes")[0];
      //   if (
      //     wm_dsa != null &&
      //     typeof wm_dsa != "undefined" &&
      //     typeof wm_values != "undefined" &&
      //     wm_values != null
      //   ) {
      //     clearInterval(addHorario);
      //     wm_values.addEventListener("change", () => {
      //       let minutosLlamar =
      //         document.getElementsByName("horario_contacto")[0].value;

      //       let minutosQuedan = DFI_client.getMinutes(minutosLlamar);
      //       minutes.value = minutosQuedan;
      //     });
      //   }
      // }, 6000);

      const modalFunctions = setInterval(() => {
        const dmv = document.querySelector("#dsa-newId");
        if (dmv && typeof dmv != "undefined") {
          clearInterval(modalFunctions);
          //Funcion abrir popPup info en modalMobile//
          const btn_moreinfo = document.getElementById("wm_mobilebtn-info");
          const modal_opened = document.querySelectorAll(".wm_popup-text");
          if (btn_moreinfo && modal_opened)
            btn_moreinfo.addEventListener("click", () => {
              DFI_client.openPopPupMobile(btn_moreinfo, modal_opened, "show");
            });
        }
      }, 3000);

      setInterval(function () {
        if (
          typeof window.DFI === "object" &&
          typeof window.DFI.telefonoRingPoolActivo === "string" &&
          window.DFI.telefonoRingPoolActivo.length > 8 &&
          wmTelInit != wmTelLast
        ) {
          wmTelInit = window.DFI.telefonoRingPoolActivo;
          wmTelLast = window.DFI.telefonoRingPoolActivo;
          /**
           * Se comenta esta linea porque esto objeto ya no existe, debido a que el cliente elimino byside
           */
          // bysideWebcare_set_calltracker_number(
          //   window.DFI.telefonoRingPoolActivo
          // )
        } else if (
          typeof window.DFI === "object" &&
          typeof window.DFI.telefonoRingPoolActivo === "string" &&
          window.DFI.telefonoRingPoolActivo.length > 8
        ) {
          wmTelLast = window.DFI.telefonoRingPoolActivo;
        }
      }, 1000);
    }
  }, 170);
}
